export default {
  status: "",
  hasLoadedOnce: false,
  counter: 0,
  employeeSession: localStorage.getItem("user-session") || false,
  user_token: localStorage.getItem("user-token") || "",
  tokenExpiry: localStorage.getItem("token-expiry") || "",
};
